export function falsy(value) {
  return value !== null && value !== void 0;
}
export function buildRequestParams(variables) {
  if (typeof variables !== "object" || !variables) {
    return {};
  }
  for (const key in variables) {
    if (typeof variables[key] !== "string") {
      return {
        __variables: JSON.stringify(variables)
      };
    }
  }
  return variables;
}
